import { useTranslation } from 'react-i18next';
import { Alert } from 'react-native';
import { BASE_API_URL } from '@env';
import { useMutation } from 'react-query';
import { useUserStore } from '~providers/userStore/zustand';

export const useCancelOrder = () => {
  const { t } = useTranslation();

  return useMutation(async (order_id: string) => {
    const token = useUserStore.getState().token;
    const response = await fetch(`${BASE_API_URL}orders/${order_id}/cancel`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: token,
      },
    });
    console.log(response, token, 'responseresponse');

    if (response.status === 404) {
      Alert.alert(t('events.event_has_been_deleted'));
    }
    if (!response.ok) {
      throw new Error('Failed to cancel the order');
    }

    const data = await response.json();
    return data;
  });
};
